import axios from "axios";
import {useMemo} from "react";
import {useQuery} from "@tanstack/react-query";

import {extractAccessToken} from "../helpers/jwt";
import {ResponseList} from "../models/common/Response";
import {EmployeeMenuConfig} from "../models/config/EmployeeMenuConfig";

export function useEmployeeMenuConfig() {
    const citizenId = useMemo(() => {
        const payload = extractAccessToken();
        return payload.citizen_id ?? payload.username;
    }, []);
    
    return useQuery({
        enabled: !!citizenId,
        queryKey: ['employee-menu-config', citizenId],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<EmployeeMenuConfig>>('/v1/configuration/lis/employee/menu', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('LG_APPLICATION')}`,
                },
                params: {
                    id: citizenId,
                }
            }),
        select: (response) => response.data.result_list,
        retry: 1
    })
}